import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class MassUpdateDateAction extends AbstractAction {
    constructor(provider, elements, field, value) {
        super(provider);

        this._elements = elements;
        this.field = field;
        this.oldValues = elements.map(el => el[field]);
        this.newValue = value || null;
    }

    finish() {
        this._elements.forEach(el => el[this.field] = this.newValue);
        this._elements.forEach(el => this.emit(EventTypes.UPDATE_ELEMENT_DATE, el));
        super.finish();
    }

    undo() {
        this._elements.forEach((el, i) => el[this.field] = this.oldValues[i]);
        this._elements.forEach(el => this.emit(EventTypes.UPDATE_ELEMENT_DATE, el));
    }

    redo() {
        this._elements.forEach(el => el[this.field] = this.newValue);
        this._elements.forEach(el => this.emit(EventTypes.UPDATE_ELEMENT_DATE, el));
    }
}
